import React, { useState, useEffect } from "react";
import { Button, Table } from "reactstrap";
import { useAuth } from "context/authContext.js";
import { msalInstance, loginRequest } from "authConfig.js";
import BeatLoader from "react-spinners/BeatLoader";
import { useAccessToken } from "context/tokenConfig.js";
import { baseurl } from "authConfig.js";
import { useClient } from "context/clientContext";
import ClientSelection from "components/SelectClient";
import { useHasChecked } from "context/hasCheckedContext.js";
import FolderTable from "./components/FolderTable.js";

const Documents = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [documentsArray, setDocumentsArray] = useState([]);
  const { login } = useAuth();
  const { accessToken } = useAccessToken();
  const [data, setData] = useState([]);
  const { hasChecked, setHasChecked } = useHasChecked();
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const { client, selectedClient } = useClient();

  const handleLogin = () => {
    msalInstance
      .loginPopup(loginRequest)
      .then(async (response) => {
        await login();
        window.location.reload();
      })
      .catch((error) => {
        console.error("Login error:", error);
      });
  };

  const getDocumentData = async () => {
    setIsLoading(true);
    try {
      const url = `${baseurl}/GetWebPresentationData?ClientId=${selectedClient}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const result = await response.json();
        setData(result);
      } else {
        console.error("Failed to fetch document data", response.status);
      }
    } catch (error) {
      console.error("Error in getDocumentData:", error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (accessToken && selectedClient !== -1) {
      getDocumentData();
    }

    if (selectedClient > 0) {
      setHasChecked(true);
    }
  }, [accessToken, selectedClient]);

  useEffect(() => {
    const typeOfFile = data.filter(
      (item) => item?.folderLabel?.toLowerCase() === "documents"
    );

    const sortedDocuments = typeOfFile.sort((a, b) => {
      return new Date(b.uploadDate) - new Date(a.uploadDate);
    });

    setDocumentsArray(sortedDocuments);
  }, [data]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...documentsArray].sort((a, b) => {
      if (key === "fileSize") {
        return direction === "asc" ? a[key] - b[key] : b[key] - a[key];
      } else if (key === "uploadDate" || key === "fileCreatedDate") {
        return direction === "asc"
          ? new Date(a[key]) - new Date(b[key])
          : new Date(b[key]) - new Date(a[key]);
      } else {
        return direction === "asc"
          ? a[key].localeCompare(b[key])
          : b[key].localeCompare(a[key]);
      }
    });

    setDocumentsArray(sortedData);
  };

  return (
    <div className="content">
      {isLoading ? (
        <div style={{ paddingTop: "150px", display: "flex", justifyContent: "center" }}>
          <BeatLoader color={"#EC2B20"} size={35} loading={isLoading} />
        </div>
      ) : (
        <>
          {accessToken === null ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "100px 50px",
              }}
            >
              <p style={{ fontSize: "20px" }}>Please log in to use this app</p>

              <Button
                onClick={handleLogin}
                style={{ backgroundColor: "#EC2B20", width: "25%" }}
                block
                className="btn-round"
              >
                Log In
              </Button>
            </div>
          ) : (
            <>
              {client === 0 && !hasChecked ? (
                <ClientSelection />
              ) : (
                hasChecked && (
                  <FolderTable
                    data={documentsArray}
                    title="List of Uploaded Documents"
                    emptyMessage="No documents to show"
                    renderTable={(rows, handleSort, sortConfig) => (
                      <Table>
                        <thead className="text-primary">
                          <tr style={{ color: "#2c2c2c" }}>
                            {selectedClient === 0 && (
                              <th>
                                Client Name
                                <button
                                  style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
                                  onClick={() => handleSort("clientName")}
                                >
                                  {sortConfig.key === "clientName" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
                                </button>
                              </th>
                            )}
                            <th>
                              File Name
                              <button
                                style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
                                onClick={() => handleSort("filename")}
                              >
                                {sortConfig.key === "filename" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
                              </button>
                            </th>
                            <th>
                              Uploaded Date
                              <button
                                style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
                                onClick={() => handleSort("uploadDate")}
                              >
                                {sortConfig.key === "uploadDate" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
                              </button>
                            </th>
                            <th>
                              File Size (MB)
                              <button
                                style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
                                onClick={() => handleSort("fileSize")}
                              >
                                {sortConfig.key === "fileSize" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((j, index) => (
                            <tr key={index}>
                              {selectedClient === 0 && <td>{j.clientName}</td>}
                              <td>{j.filename}</td>
                              <td>{new Date(j?.uploadDate).toLocaleDateString("en-GB")}</td>
                              <td>{j.fileSize}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  />
                )
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Documents;
